import { defineComponent, computed, openBlock, createElementBlock, createBlock, unref, Fragment, createVNode, mergeProps, normalizeClass, createCommentVNode, createElementVNode } from "vue";
import _sfc_main$1 from "../MembershipRewardsTag/MembershipRewardsTag.mjs";
/* empty css                                             */
import ElevatedSpecs from "../ElevatedSpecs/ElevatedSpecs3.mjs";
import StaffTestimonialAlternate from "../StaffTestimonialAlternate/StaffTestimonialAlternate.mjs";
import { EStaffTestimonialVariants } from "../StaffTestimonial/StaffTestimonial.mjs";
/* empty css                                     */
import BuyBoxPup from "./BuyBoxPup/BuyBoxPup.mjs";
import BuyBoxPrice from "./BuyBoxPrice/BuyBoxPrice.mjs";
import BuyBoxAlertMessage from "./BuyBoxAlertMessage/BuyBoxAlertMessage.mjs";
import BuyBoxPurchaseForm from "./BuyBoxPurchaseForm/BuyBoxPurchaseForm.mjs";
import _sfc_main$2 from "./BuyBoxReturnPolicy/BuyBoxReturnPolicy.mjs";
import BuyBoxProductDescription from "./BuyBoxProductDescription/BuyBoxProductDescription.mjs";
import { EElevatedSpecsCase } from "../ElevatedSpecs/ElevatedSpecs.mjs";
const _hoisted_1 = {
  key: 3,
  class: "buy-box__elevated-specs--hide-desktop"
};
const _hoisted_2 = {
  key: 4
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "BuyBox",
  props: {
    buyBoxAlertMessage: {
      default: null
    },
    price: {},
    displayPrice: {},
    flairBadge: {
      default: null
    },
    offerType: {
      default: ""
    },
    priceInfo: {},
    pupInfo: {},
    purchaseFormProps: {},
    description: {
      default: ""
    },
    estimatedRewardsText: {
      default: ""
    },
    showEstimatedRewards: {
      type: Boolean,
      default: false
    },
    elevatedSpecs: {},
    elevatedSpecsDesktopType: {
      default: EElevatedSpecsCase.CONTROL
    },
    elevatedSpecsMobileType: {
      default: EElevatedSpecsCase.CONTROL
    },
    staffTestimonialProps: {
      default: void 0
    },
    staffTestimonialExperience: {
      default: EStaffTestimonialVariants.CONTROL
    }
  },
  emits: ["addToCart", "addToWishlist", "carouselHover", "colorHover", "colorUpdate", "dividendClick", "emailUpdate", "includeMembership", "loadCmsContent", "memberInfoClick", "metricsClick", "modalOpen", "openDisclaimerModal", "notifyMe", "oversizeInfoClick", "qtyUpdate", "registerRef", "shipUpdate", "shippingInfoClick", "sizeClick", "sizeChartClick", "sizeHover", "sizeUpdate", "skuSelectUpdate", "storeFinderClick", "updateAddress", "updateGeolocation", "updateEditorOpen", "clearGeolocationError", "preorderBannerClick"],
  setup(__props) {
    const props = __props;
    const showElevatedSpecs = computed(() => props.elevatedSpecs && (props.elevatedSpecsDesktopType === EElevatedSpecsCase.BUY_BOX || props.elevatedSpecsMobileType === EElevatedSpecsCase.BUY_BOX));
    const isBuyBoxVariantDesktop = computed(() => props.elevatedSpecsDesktopType === EElevatedSpecsCase.BUY_BOX);
    const isBuyBoxVariantMobile = computed(() => props.elevatedSpecsMobileType === EElevatedSpecsCase.BUY_BOX);
    const isBelowBuyBoxVariant = computed(() => props.elevatedSpecsMobileType === EElevatedSpecsCase.BELOW_BUY_BOX);
    const showStaffTestimonial = computed(() => props.staffTestimonialExperience === EStaffTestimonialVariants.BUY_BOX && props.staffTestimonialProps);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", null, [_ctx.pupInfo.isPup ? (openBlock(), createBlock(unref(BuyBoxPup), {
        key: 0,
        class: "product-page__buy-box-pup",
        "message-text": _ctx.pupInfo.messageText,
        "cta-text": _ctx.pupInfo.ctaText,
        description: _ctx.description,
        href: _ctx.pupInfo.ctaHref,
        onMetricsClick: _cache[0] || (_cache[0] = (data) => _ctx.$emit("metricsClick", data))
      }, null, 8, ["message-text", "cta-text", "description", "href"])) : (openBlock(), createElementBlock(Fragment, {
        key: 1
      }, [createVNode(unref(BuyBoxPrice), mergeProps({
        class: ["buy-box__price", {
          "buy-box__price--flair": _ctx.flairBadge
        }],
        price: _ctx.price,
        "display-price": _ctx.displayPrice,
        "flair-badge": _ctx.flairBadge
      }, _ctx.priceInfo, {
        onModalOpen: _cache[1] || (_cache[1] = (modalProps) => _ctx.$emit("modalOpen", modalProps)),
        onOpenDisclaimerModal: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("openDisclaimerModal"))
      }), null, 16, ["class", "price", "display-price", "flair-badge"]), _ctx.showEstimatedRewards ? (openBlock(), createBlock(unref(_sfc_main$1), {
        key: 0,
        text: _ctx.estimatedRewardsText,
        class: normalizeClass({
          "buy-box__membership-rewards-tag--spaced": !!_ctx.buyBoxAlertMessage
        })
      }, null, 8, ["text", "class"])) : createCommentVNode("", true), _ctx.buyBoxAlertMessage ? (openBlock(), createBlock(unref(BuyBoxAlertMessage), mergeProps({
        key: 1,
        class: "buy-box__alert-msg"
      }, _ctx.buyBoxAlertMessage), null, 16)) : createCommentVNode("", true), createVNode(unref(BuyBoxProductDescription), {
        class: normalizeClass(["buy-box__description", {
          "buy-box__description--buy-box-mobile": isBuyBoxVariantMobile.value,
          "buy-box__description--buy-box-desktop": isBuyBoxVariantDesktop.value,
          "buy-box__description--below-buy-box-mobile": isBelowBuyBoxVariant.value
        }]),
        description: _ctx.description
      }, null, 8, ["class", "description"]), showElevatedSpecs.value ? (openBlock(), createBlock(unref(ElevatedSpecs), {
        key: 2,
        class: normalizeClass(["buy-box__elevated-specs--buy-box", {
          "buy-box__elevated-specs--hide-desktop": !isBuyBoxVariantDesktop.value,
          "buy-box__elevated-specs--hide-mobile": !isBuyBoxVariantMobile.value
        }]),
        specs: _ctx.elevatedSpecs,
        type: unref(EElevatedSpecsCase).BUY_BOX
      }, null, 8, ["class", "specs", "type"])) : createCommentVNode("", true), createVNode(unref(BuyBoxPurchaseForm), mergeProps({
        class: "buy-box__purchase-form"
      }, _ctx.purchaseFormProps, {
        onAddToCart: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("addToCart")),
        onAddToWishlist: _cache[4] || (_cache[4] = (wishlist) => _ctx.$emit("addToWishlist", wishlist)),
        onCarouselHover: _cache[5] || (_cache[5] = (color) => _ctx.$emit("carouselHover", color)),
        onColorUpdate: _cache[6] || (_cache[6] = (data) => _ctx.$emit("colorUpdate", data)),
        onColorHover: _cache[7] || (_cache[7] = (data) => _ctx.$emit("colorHover", data)),
        onDividendClick: _cache[8] || (_cache[8] = ($event) => _ctx.$emit("dividendClick")),
        onMemberInfoClick: _cache[9] || (_cache[9] = ($event) => _ctx.$emit("memberInfoClick")),
        onIncludeMembership: _cache[10] || (_cache[10] = (data) => _ctx.$emit("includeMembership", data)),
        onMetricsClick: _cache[11] || (_cache[11] = (data) => _ctx.$emit("metricsClick", data)),
        onModalOpen: _cache[12] || (_cache[12] = (modalProps) => _ctx.$emit("modalOpen", modalProps)),
        onOversizeInfoClick: _cache[13] || (_cache[13] = (data) => _ctx.$emit("oversizeInfoClick", data)),
        onQtyUpdate: _cache[14] || (_cache[14] = (qty) => _ctx.$emit("qtyUpdate", qty)),
        onRegisterRef: _cache[15] || (_cache[15] = (ref) => _ctx.$emit("registerRef", ref)),
        onShipUpdate: _cache[16] || (_cache[16] = (method) => _ctx.$emit("shipUpdate", method)),
        onShippingInfoClick: _cache[17] || (_cache[17] = (data) => _ctx.$emit("shippingInfoClick", data)),
        onSizeUpdate: _cache[18] || (_cache[18] = (data) => _ctx.$emit("sizeUpdate", data)),
        onSizeClick: _cache[19] || (_cache[19] = (data) => _ctx.$emit("sizeClick", data)),
        onSizeHover: _cache[20] || (_cache[20] = (data) => _ctx.$emit("sizeHover", data)),
        onSkuSelectUpdate: _cache[21] || (_cache[21] = (data) => _ctx.$emit("skuSelectUpdate", data)),
        onStoreFinderClick: _cache[22] || (_cache[22] = (data) => _ctx.$emit("storeFinderClick", data)),
        onEmailUpdate: _cache[23] || (_cache[23] = (data) => _ctx.$emit("emailUpdate", data)),
        onNotifyMe: _cache[24] || (_cache[24] = (data) => _ctx.$emit("notifyMe", data)),
        onSizeChartClick: _cache[25] || (_cache[25] = (data) => _ctx.$emit("sizeChartClick", data)),
        onUpdateAddress: _cache[26] || (_cache[26] = (data) => _ctx.$emit("updateAddress", data)),
        onUpdateGeolocation: _cache[27] || (_cache[27] = (data) => _ctx.$emit("updateGeolocation", data)),
        onUpdateEditorOpen: _cache[28] || (_cache[28] = (data) => _ctx.$emit("updateEditorOpen", data)),
        onClearGeolocationError: _cache[29] || (_cache[29] = ($event) => _ctx.$emit("clearGeolocationError")),
        onPreorderBannerClick: _cache[30] || (_cache[30] = (data) => _ctx.$emit("preorderBannerClick", data))
      }), null, 16), createVNode(unref(_sfc_main$2), {
        "cms-key": "returnPolicyModal",
        class: "buy-box__return-policy",
        onLoadCmsContent: _cache[31] || (_cache[31] = (data) => _ctx.$emit("loadCmsContent", data)),
        onMetricsClick: _cache[32] || (_cache[32] = (data) => _ctx.$emit("metricsClick", data))
      }), isBelowBuyBoxVariant.value ? (openBlock(), createElementBlock("section", _hoisted_1, [_cache[33] || (_cache[33] = createElementVNode("h2", {
        class: "buy-box__elevated-specs-heading"
      }, " The Details ", -1)), createVNode(unref(BuyBoxProductDescription), {
        class: "buy-box__description",
        description: _ctx.description
      }, null, 8, ["description"]), createVNode(unref(ElevatedSpecs), {
        specs: _ctx.elevatedSpecs,
        type: unref(EElevatedSpecsCase).BELOW_BUY_BOX
      }, null, 8, ["specs", "type"])])) : createCommentVNode("", true), showStaffTestimonial.value ? (openBlock(), createElementBlock("section", _hoisted_2, [createVNode(unref(StaffTestimonialAlternate), mergeProps(_ctx.staffTestimonialProps, {
        class: "buy-box__staff-testimonial"
      }), null, 16)])) : createCommentVNode("", true)], 64))]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=BuyBox2.mjs.map
